<!--
    柱状统计图公共组件
-->
<template>
    <div class="statistics-upload-top">
        <div class="ibox">
            <div class="content-header">
                <div class="header-icon">
                    <i class="nucfont inuc-bar-chart"></i>
                </div>
                <span class="title">{{statisticName}} <span
                    style="color: #333;">{{sourceType?'('+sourceType+')':null}}</span></span>
            </div>
            <el-row class="content_detail">
                <el-col class="resource-type">
                    <el-card>
                        <div v-show="uploadOrderShow" :id="id" class="knowledgeBox upload-width"></div>
                        <p v-show="!uploadOrderShow" class="emptyBox">
                            <i class="nucfont inuc-empty-file"></i>
                            {{$t('c.noData')}}</p>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>

    var echarts = require('echarts');
    export default {
        props: ['statisticName', 'id', 'sourceType', 'legendName'],
        data() {
            return {
                uploadOrderShow: false,
                uploadId: this.id
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            upLoadSeption(data, id, options={}) {
                //let uploadOrderChart = echarts.init(document.getElementById(this.id));
                let uploadOrderChart = echarts.init(document.getElementById(id));
                uploadOrderChart.showLoading();
                let obj = {};
                obj.name = this.legendName ? this.legendName : this.$t('count.quantity');
                obj.nameData = [];
                obj.nameData.push(obj.name);
                // obj.xAxisData = [];
                obj.xAxisData = new Array(10);
                for(let i = 0;i < 10;i++){
                    obj.xAxisData[i]='';
                }
                obj.seriesData = [];
                const colorList =  ['#09bcd0', '#1bbbc7', '#33b9bc', '#4eb9af', '#6bb8a2', '#89b694', '#a6b586', '#c2b479', '#dbb36e', '#eeb164', '#fdb165',
                    '#ffbb77', '#ffc489', '#ffce9d', '#ffd7b0', '#ffe1c4', '#fbe4cd', '#ffeddc'];
                obj.color = {
                    color: function (params) {
                        return {
                            type: 'linear',
                            x: 0,
                            y: 1,
                            x2: 1,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: colorList[params.dataIndex]
                            }, {
                                offset: 1,
                                color: colorList[params.dataIndex + 1]
                            }],
                            globalCoord: false
                        }
                    }
                };
                if (data) {
                    if (data.length > 0) {
                        this.uploadOrderShow = true;
                        data.forEach((elem, index) => {
                            // obj.xAxisData.push(elem.name);
                            obj.xAxisData[index] = elem.name;
                            obj.seriesData.push(elem.value);
                        });
                        //制定图标的配置项和数据
                        let option = {
                            tooltip: {
                                trigger: 'item',
                                confine: true,
                            },
                            legend: {
                                data: obj.nameData,
                                icon: 'rect',
                                itemWidth: 25,
                                itemHeight: 5,
                                left: '0'
                            },
                            grid: {
                                left: '0',
                                right: '0',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: {
                                data: obj.xAxisData,
                                axisLabel: {//坐标轴刻度标签的相关设置。
                                    interval: 0,
                                    padding: [8, 0, 0, 0],
                                    formatter: function (val) {
                                        return val.length > 8 ? val.substr(0, 7) + "..." : val;
                                    }
                                },
                            },
                            yAxis: [
                                {
                                    type: 'value'
                                }
                            ],
                            series: [{
                                name: obj.name,
                                type: 'bar',
                                barMaxWidth: 30,
                                data: obj.seriesData,
                                itemStyle: {
                                    normal: obj.color
                                },
                                ...options.series
                            }]
                        };

                        uploadOrderChart.hideLoading();
                        uploadOrderChart.setOption(option);
                    } else {
                        uploadOrderChart.hideLoading();
                        this.uploadOrderShow = false;
                    }
                } else {
                    uploadOrderChart.hideLoading();
                    this.uploadOrderShow = false;
                }
            },
        },
        name: "StatisticsUploadTop"
    }
</script>

<style scoped lang="scss">
    @import '../../style/const';

    .toolDiv {
        height: auto;
    }

    .ibox {
        & /deep/ .el-card {
            border: none;
        }
        & /deep/ .el-card.is-always-shadow {
            box-shadow: none;
        }
        & /deep/ .el-card__body {
            padding: 20px 0;
        }
        clear: both;
        margin-bottom: 20px;
        margin-top: 0;
        padding: 0;
        border: none;
        background-color: #fff;
        box-shadow: 0 0 15px #e1e0d8;
        .content-header {
            height: 40px;
            background: #f4f3f8;
            .header-icon {
                display: inline-block;
                height: 40px;
                width: 45px;
                line-height: 40px;
                text-align: center;
                border-right: 1px solid #ccc;
                box-shadow: 1px 0 0 #fff;
                color: #2e7faa;
                .nucfont {
                    font-size: 20px;
                    .inuc-menu-assemble {
                        font-size: 18px;
                    }
                }
            }
            .title {
                height: 40px;
                line-height: 40px;
                padding-left: 10px;
                color: #333;
                font-size: 16px;
            }
        }
        .content_detail {
            padding: 20px;
            display: flex;
            .resource-type {
                flex: 1;
                margin: 0 5px;
                .knowledgeBox {
                    width: 1030px;
                    min-width: 1000px;
                    height: 320px;
                    margin: auto;
                }
                .emptyBox {
                    text-align: center;
                    height: 320px;
                    line-height: 320px;
                    margin: auto;
                }
            }
        }
    }
</style>
